var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpenOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336 112a80 80 0 00-160 0v96",
    fill: "none",
    stroke: "#8400E6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 208,
    width: 320,
    height: 272,
    rx: 48,
    ry: 48,
    fill: "none",
    stroke: "#8400E6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenOutline);
export default __webpack_public_path__ + "static/media/lock-open-outline.969a0b5ef3fff58e00379a9cd9597194.svg";
export { ForwardRef as ReactComponent };